import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";

export const getIpAddress = createAsyncThunk<
  string
>(
  "app-state-slice/get-ip-address",
  async (
    _,
    { signal, rejectWithValue, fulfillWithValue }
  ) => {
    const response = await axios.get<{ip: string}>('https://api.ipify.org?format=json', { signal });

    if (response.status !== HttpStatusCode.Ok) {
      return rejectWithValue((response.data));
    }
    return fulfillWithValue(response.data.ip);
  }
);
